import { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { SettingsContext } from "src/contexts/settings-context";
import GlassBackground from "src/components/GlassBackground";

const SIDE_NAV_WIDTH = 270; //280

const VerticalLayoutRoot = styled("div")(({ theme, open, isNewInterfaceEnabled }) => ({
    display: "flex",
    flex: "1 1 auto",
    maxWidth: "100%",
    background: isNewInterfaceEnabled ? "transparent" : "rgba(248, 248, 249, 1)",
}));

const VerticalLayoutContainer = styled("div")({
    position: "relative",
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    width: "100%",
    height: "100%",
});

// Simplified debounce function
function debounce(func, wait) {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(context, args);
        }, wait);
    };
}

// Main component - make sure it's a proper function component
const VerticalLayoutAuth = (props) => {
    const { children } = props;
    const [open, setOpen] = useState(false);
    const { isNewInterfaceEnabled } = useContext(SettingsContext);
    const getDomainFromLocation = () => {
    const domain = window.location.hostname;
    return domain;
    };

    const domain = getDomainFromLocation();
    const isB2bDomain = (domain === "app.b2brocket.ai" || domain === "qa.b2brocket.ai" || domain === "localhost");

    return (
        <>
            {/* {isNewInterfaceEnabled && (
                <>
                    <Box
                        id="background-overlay"
                        sx={{
                            position: "fixed",
                            width: "100%",
                            height: "100%",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundImage: (theme) =>
                                theme.palette.mode === "dark"
                                    ? "linear-gradient(180deg,hsla(0,0%,0%,0.4) 0%,hsla(0,0%,0%,0.1) 15%, hsla(0,0%,0%,0) 30%, hsla(0,0%,0%,0) 50%, hsla(0,0%,0%,0) 100%)"
                                    : "linear-gradient(180deg,hsla(0,0%,100%,0.4) 0%,hsla(0,0%,100%,0) 100%)",
                            backgroundSize: "cover",
                            zIndex: "-1",
                        }}
                    />
                    <Box
                        className="glass-background-image"
                        sx={{
                            position: "fixed",
                            width: "100%",
                            height: "100%",
                            zIndex: "-1"
                        }}
                    >
                        <img
                            src={bg4}
                            alt="Background"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover"
                            }}
                        />
                    </Box>
                </>
            )} */}
            {(isNewInterfaceEnabled && isB2bDomain) && <GlassBackground />}

            <VerticalLayoutRoot open={open} isNewInterfaceEnabled={isNewInterfaceEnabled}>
                <VerticalLayoutContainer>
                    {children || <div>here we are again</div>}
                </VerticalLayoutContainer>
            </VerticalLayoutRoot>
        </>
    );
};

export default VerticalLayoutAuth;



